import React from "react";
import { inject, observer } from "mobx-react";
import BaseMLBTrackingAccuracyReportContainer from "./BaseMLBTrackingAccuracyReportContainer";
import NGETrackingAccuracyReportTable from "../components/accuracyReports/nge/NGETrackingAccuracyReportTable";
import IncidentTypes from "../constants/IncidentTypes";
import NGEGameActionDropDownContainer from "./NGEGameActionDropDownContainer";

class NGETrackingAccuracyReportContainer extends React.Component {
  render() {
    const rootStore = this.props.rootStore;
    const description =
      "A real-time pitch-by-pitch data report that monitors the overall quality of data and video systems used for Non-Game Events.";
    const reportTable = (
      <NGETrackingAccuracyReportTable
        data={rootStore.NGEGameActionStore.trackingAccuracyReportSource.data}
        gameStatuses={rootStore.veracityStore.gameStatuses}
        canCreateIncident={rootStore.authStore.hasIncidentEdit}
        groupsToShow={rootStore.tableControlsStore.state}
        dropDownContainer={NGEGameActionDropDownContainer}
      />
    );
    return (
      <BaseMLBTrackingAccuracyReportContainer
        header="Non-Game Events Statcast Data & Coaching Video Report"
        description={description}
        reportSource={rootStore.NGEGameActionStore.trackingAccuracyReportSource}
        reportTable={reportTable}
        incidentTypesToFetch={[IncidentTypes.NGE, IncidentTypes.SYSTEM]}
        showSystemIncidentButton={rootStore.authStore.hasIncidentEdit}
        hideLegend
      />
    );
  }
}

export default inject("rootStore")(
  observer(NGETrackingAccuracyReportContainer),
);
